import { useEffect } from "react";

export const SITE_URL = "https://thriveon.fit";
export const PLAY_STORE_URL =
  "https://play.google.com/store/apps/details?id=com.enbydev.thriveon";
export const DEFAULT_OG_IMAGE = `${SITE_URL}/assets/dashboard.png`;

/**
 * Upserts <meta name="..."> / <meta property="..."> without pulling in
 * react-helmet. Tags created here are marked data-seo so a later render can
 * find and reuse them instead of appending duplicates.
 */
function setMeta(attr, key, content) {
  if (!content) return;
  let tag = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!tag) {
    tag = document.createElement("meta");
    tag.setAttribute(attr, key);
    tag.setAttribute("data-seo", "");
    document.head.appendChild(tag);
  }
  tag.setAttribute("content", content);
}

function setCanonical(href) {
  let link = document.head.querySelector('link[rel="canonical"]');
  if (!link) {
    link = document.createElement("link");
    link.setAttribute("rel", "canonical");
    link.setAttribute("data-seo", "");
    document.head.appendChild(link);
  }
  link.setAttribute("href", href);
}

/**
 * Per-route document metadata.
 *
 * The landing page's values are also hard-coded into public/index.html so that
 * a crawler which does not execute JavaScript still gets them. If you change
 * the landing page copy here, change it there too.
 *
 * @param {string} path  Route path, e.g. "/privacy-policy". Used for canonical.
 * @param {boolean} noindex  Keep the page out of search results.
 */
export default function Seo({
  title,
  description,
  path = "/",
  image = DEFAULT_OG_IMAGE,
  noindex = false,
}) {
  useEffect(() => {
    const url = `${SITE_URL}${path}`;

    if (title) document.title = title;
    setMeta("name", "description", description);
    setCanonical(url);
    setMeta(
      "name",
      "robots",
      noindex ? "noindex, nofollow" : "index, follow, max-image-preview:large",
    );

    setMeta("property", "og:title", title);
    setMeta("property", "og:description", description);
    setMeta("property", "og:url", url);
    setMeta("property", "og:image", image);
    setMeta("property", "og:type", "website");
    setMeta("property", "og:site_name", "ThriveOn");

    setMeta("name", "twitter:card", "summary_large_image");
    setMeta("name", "twitter:title", title);
    setMeta("name", "twitter:description", description);
    setMeta("name", "twitter:image", image);
  }, [title, description, path, image, noindex]);

  return null;
}